import React from "react";

export default function Footer() {
  return (
    <footer id="footer" className="bg-gray-900 text-white py-6 text-center">
      <p className="flex flex-col sm:flex-row justify-center gap-4 text-sm sm:text-base">
        <span>Email: <a href="mailto:info@opslytic.com" className="text-blue-400 hover:underline">info@opslytic.com</a></span>
        <span>Mobile: <a href="tel:+919422110467" className="text-blue-400 hover:underline">+91 9422110467</a></span>
        <span>2025 Opslytic</span>
      </p>
      {/* <p>&copy; {new Date().getFullYear()} Opslytic. All rights reserved.</p> */}
    </footer>
  );
}
